import { render, staticRenderFns } from "./customIcon.vue?vue&type=template&id=581e6288&scoped=true"
import script from "./customIcon.vue?vue&type=script&lang=js"
export * from "./customIcon.vue?vue&type=script&lang=js"
import style0 from "./customIcon.vue?vue&type=style&index=0&id=581e6288&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581e6288",
  null
  
)

export default component.exports